export default __webpack_public_path__ + "static/impact-ready-fill-777d3bed077f0e81765b6c353fd5a3f8.svg";